export const normalizeLanguage = (lang: string) => {
  if (lang == 'jp') return 'ja';
  if (lang == 'kr') return 'ko';
  if (lang == 'sp') return 'es';
  return lang;
};
